import { VSelect } from '../VSelect';
import { useVPeriodSelectorContext } from './hook';

export const VAggregationSelectField = () => {
  const {
    aggregationGapList,
    aggregationGapValue,
    onAggregationGapChange,
    enableAggregationGap,
  } = useVPeriodSelectorContext<true>();

  if (!enableAggregationGap) return null;

  return (
    <VSelect
      value={aggregationGapValue}
      size="sm"
      label="Aggregation Gap"
      orientation="horizontal"
      onChange={e => onAggregationGapChange?.(e.target.value)}
      itemList={
        aggregationGapList?.map(item => ({
          value: item.value,
          label: item.label,
        })) ?? []
      }
    />
  );
};
